// import { Helmet } from 'react-helmet-async';
// import { Link } from 'react-router-dom';
// // @mui
// import { Button, Container, Stack, Typography } from '@mui/material';
// import { useSelector } from 'react-redux';
// import { useEffect, useState } from 'react';
// import axios from 'axios';
// import Swal from 'sweetalert2';

// // components
// import Iconify from '../components/iconify';
// import ProductDataList from '../sections/@dashboard/products/ProductDataList';
// import { Url } from '../url/url';

// // import ProductDataList from 'src/sections/@dashboard/products/ProductDataList';



// // ----------------------------------------------------------------------
// const SORT_OPTIONS = [
//   { value: 'latest', label: 'Latest' },
//   { value: 'popular', label: 'Popular' },
//   { value: 'oldest', label: 'Oldest' },
// ];
// // ----------------------------------------------------------------------
// const initialValue = {
//   data: [],
//   totalCount: 0,
//   totalPages: 1,
//   currentPage: 1
// }
// const ProductsPage = () => {
//   const productAllData = useSelector(store => store.product.data)
//   const categoryAllData = useSelector(store => store.category.data)
//   const [searchData, setSearchValueData] = useState()
//   const [dataValue, setDataValue] = useState([])

//   const [product, setProduct] = useState(initialValue)
//   const [limit, setLimit] = useState(5)
//   const [totalPage, setTotalPage] = useState(1)
//   const [currentPage, setCurrentPage] = useState(1)


//   const searchfunc = async (value) => {
//     if (value.length > 0) {
//       let findproduct = await axios.get(`${Url}/product/search/${value}`)
//       findproduct = findproduct.data
//       setSearchValueData(findproduct)
//     }
//     else {
//       setSearchValueData()
//     }
//   }

//   const dataSet = (categoryvalue) => {
//     if (categoryvalue) {
//       if (categoryvalue) {
//         setDataValue(productAllData.filter(val => val.category === categoryvalue))
//       }
//       else {
//         setDataValue(productAllData)
//       }
//     }
//     else {
//       setDataValue(productAllData)
//     }
//   }

//   const fetchDataFunc = async () => {
//     try {
//       const response = await axios.get(`${Url}/product?limit=${limit}&page=${currentPage}`).then(data => data.data)
//       setTotalPage(response.totalPages)
//       setProduct(response)
//     } catch (error) {
//       console.log("error", error);
//     }
//   }

//   const productDrop = async (id) => {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!'
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         await axios.delete(`${Url}/product/delete/${id}`).then(() => {
//           Swal.fire({
//             position: 'top-end',
//             icon: 'success',
//             title: 'Item Delete Successfully',
//             showConfirmButton: false,
//             timer: 1000
//           })
//           // dispatch(productdata())
//         }).catch((error) => {
//           Swal.fire({
//             position: 'top-end',
//             icon: 'error',
//             title: 'something went wrong',
//             showConfirmButton: false,
//             timer: 1500
//           })
//         })

//       }
//     })
//   }

//   const updateProductTagFunc = async(id, tag)=>{ 
//     try {
//       await axios.put(`${Url}/product/update-product-tag/${id}`, {tag})
//       fetchDataFunc()
//     } catch (error) {
//       console.log(error);
      
//     }
//   }

//   const onPageChange = (pageNumber) => {
//     setCurrentPage(pageNumber)
//   }
//   const changeLimitFunc = (limitNumber) => { 
//     setLimit(limitNumber)
//     setCurrentPage(1)
//   }
 
//   useEffect(() => {
//     fetchDataFunc()
//   }, [currentPage, limit])

//   useEffect(() => {
//     dataSet()
//   }, [productAllData])


//   return (
//     <>
//       <Helmet>
//         <title> Dashboard: Products | Doozie-do </title>
//       </Helmet>

//       <Container>
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
//           <Typography variant="h4" gutterBottom>
//             Product
//           </Typography>
//           <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
//             <Link className='text-white ' to="/dashboard/add-product">Add New</Link>
//           </Button>
//         </Stack>
//       </Container>

//       <Container className=' '>
//         <div className='d-flex align-items-center justify-content-between felx-wrap bg-lightgray rounded-top p-3'>
//           <div>
//             <form>
//               <input type='text' onChange={e => searchfunc(e.target.value)} placeholder='Search' className='form-control' />
//             </form>
//           </div>
//           <div className='d-flex gap-2 align-items-top'>
//             {/* <div >
//               <p className='mb-1 me-2'>Category </p> 
//                 <select onChange={e => dataSet(e.target.value)} className='border-0 rounded p-1'>
//                   <option value="">All</option>
//                   {categoryAllData.map((cv, i) => {
//                     return (
//                       <option value={cv.category} className='text-capitalize' key={i}>{cv.category} </option>
//                     )
//                   })}
//                 </select> 
//             </div> */}
//             <div>
//               <p className='mb-1'>Limit</p>
//               <select value={limit} onChange={e => changeLimitFunc(e.target.value)} className='border-0 rounded p-1'>
//                 <option value="5">5</option>
//                 <option value="10">10</option>
//                 <option value="20">20</option>
//                 <option value="30">30</option>
//                 <option value="50">50</option>
//                 <option value="100">100</option>
//               </select>
//             </div>
//           </div>
//         </div>
//       </Container>
//       <Container>
//         <section className='table-responsive'>
//           <table className='table table-striped table-bordered text-center table-hover align-top'>
//             <thead className='table-primary'>
//               <tr className='align-top'>
//                 <th>Product Image</th>
//                 <th>Product Name</th>
//                 <th>Seller Name</th>
//                 <th>Character</th>
//                 <th>SubCharacter</th>
//                 <th>MRP</th>
//                 <th>Sale Price</th>
//                 <th>Tag</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {product.data?.map((cv, i) => {
//                 return (
//                   <tr className='text-center' key={i}>
//                     <td className=''>
//                       <img src={`${cv.thumbnailImage}`} alt="" className='img-fluid mx-auto' style={{ width: "70px" }} />
//                     </td>
//                     <td className=''>{cv.productName}</td>
//                     {/* <td  className=''>{cv.category}</td> */}
//                     {/* <td  className=''>{cv.subcategory}</td> */}
//                     <td className=''>{cv.sellerName}</td>
//                     <td className=''>{cv.character}</td>
//                     <td className=''>{cv.subcharacter}</td>
//                     <td className=''>&#8377; {cv.mrp}</td>
//                     <td className=''>&#8377; {cv.salePrice}</td>
//                     {/* <td>{cv.tags}</td> */}
//                     <td>
//                       <select name="tags" id="" className='form-select' value={cv.tags} onChange={(e)=>updateProductTagFunc(cv._id, e.target.value)}>
//                         <option value="">Null</option>
//                         <option value="top picks">Top Picks  </option>
//                         <option value="new arrival">New Arrival  </option>
//                       </select>
//                     </td>
//                     <td  >
//                       <div className='d-flex align-items-center'>
//                         <Link to={`/dashboard/updateproduct/${cv._id}`} className='btn border-0'>
//                           <i className="fa-solid fa-pen-to-square text-warning fa-lg " /> <br />
//                         </Link>
//                         <button className='btn border-0' onClick={e => productDrop(cv._id)}>
//                           <i className="fa-solid fa-trash text-danger fa-lg" />
//                         </button>
//                         <Link className='btn border-0' to={`/dashboard/product/${cv._id}`}>
//                           <i className="fa-solid fa-eye text-primary fa-lg" />
//                         </Link>
//                       </div>
//                     </td>
//                   </tr>
//                 )
//               })}
//             </tbody>
//           </table>
//         </section>

//         <nav >
//           <ul className="pagination justify-content-center">
//             {/* Previous Button */}
//             <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//               <button className="page-link" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
//                 Previous
//               </button>
//             </li>

//             {/* Page Numbers */}
//             {Array.from({ length: totalPage }, (_, index) => index + 1).map((page) => (
//               <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
//                 <button className="page-link" onClick={() => onPageChange(page)}>
//                   {page}
//                 </button>
//               </li>
//             ))}

//             {/* Next Button */}
//             <li className={`page-item ${currentPage === totalPage ? "disabled" : ""}`}>
//               <button className="page-link" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPage}>
//                 Next
//               </button>
//             </li>
//           </ul>
//         </nav>

//       </Container>
//       <Container>
//         {/* {searchData ? <ProductDataList data={searchData} /> : <ProductDataList data={dataValue} />} */}
//       </Container>



//     </>
//   );
// }

// export default ProductsPage





// /* eslint-disable object-shorthand */
// /* eslint-disable react/jsx-no-bind */
// import { Helmet } from 'react-helmet-async';
// import { Link } from 'react-router-dom';
// // @mui
// import { Button, Container, Stack, Typography, Tabs, Tab, Box } from '@mui/material';
// import { useSelector } from 'react-redux';
// import { useEffect, useState, useMemo } from 'react';
// import axios from 'axios';
// import Swal from 'sweetalert2';

// // components
// import Iconify from '../components/iconify';
// import ProductDataList from '../sections/@dashboard/products/ProductDataList';
// import { Url } from '../url/url';

// // ----------------------------------------------------------------------
// const SORT_OPTIONS = [
//   { value: 'latest', label: 'Latest' },
//   { value: 'popular', label: 'Popular' },
//   { value: 'oldest', label: 'Oldest' },
// ];
// // ----------------------------------------------------------------------
// const initialValue = {
//   data: [],
//   totalCount: 0,
//   totalPages: 1,
//   currentPage: 1
// }

// const ProductsPage = () => {
//   const productAllData = useSelector(store => store.product.data)
//   const categoryAllData = useSelector(store => store.category.data)
//   const [searchData, setSearchValueData] = useState()
//   const [dataValue, setDataValue] = useState([])
// console.log("productAllData",productAllData)
//   const [allProductsData, setAllProductsData] = useState([])
//   const [limit, setLimit] = useState(5)
//   const [currentPage, setCurrentPage] = useState(1)
//   const [activeTab, setActiveTab] = useState(0)

//   async function searchfunc(value) {
//     if (value.length > 0) {
//       let findproduct = await axios.get(`${Url}/product/search/${value}`)
//       findproduct = findproduct.data
//       setSearchValueData(findproduct)
//     }
//     else {
//       setSearchValueData()
//     }
//   }

//   function dataSet(categoryvalue) {
//     if (categoryvalue) {
//       if (categoryvalue) {
//         setDataValue(productAllData.filter(val => val.category === categoryvalue))
//       }
//       else {
//         setDataValue(productAllData)
//       }
//     }
//     else {
//       setDataValue(productAllData)
//     }
//   }

//   // useMemo se filtered data calculate karo
//   const filteredProducts = useMemo(() => {
//     let filtered = [...allProductsData]
    
//     if (activeTab === 1) {
//       filtered = filtered.filter(item => item.sellerName && item.sellerName === 'Devi Shera')
//     } else if (activeTab === 2) {
//       filtered = filtered.filter(item => item.sellerName && item.sellerName.toLowerCase() === 'doozie-do')
//     }
    
//     return filtered
//   }, [allProductsData, activeTab])

//   // useMemo se paginated data calculate karo
//   const paginatedData = useMemo(() => {
//     const totalCount = filteredProducts.length
//     const pages = Math.ceil(totalCount / limit)
    
//     const start = (currentPage - 1) * limit
//     const end = start + Number(limit)
//     const paginated = filteredProducts.slice(start, end)
    
//     return {
//       data: paginated,
//       totalCount: totalCount,
//       totalPages: pages,
//       currentPage: currentPage
//     }
//   }, [filteredProducts, limit, currentPage])

//   async function fetchDataFunc() {
//     try {
//       const response = await axios.get(`${Url}/product?limit=1000&page=1`)
//       const fetchedData = response.data.data || []
//       setAllProductsData(fetchedData)
//     } catch (error) {
//       console.log("error", error);
//     }
//   }

//   async function productDrop(id) {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!'
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         await axios.delete(`${Url}/product/delete/${id}`).then(() => {
//           Swal.fire({
//             position: 'top-end',
//             icon: 'success',
//             title: 'Item Delete Successfully',
//             showConfirmButton: false,
//             timer: 1000
//           })
//           fetchDataFunc()
//         }).catch((error) => {
//           Swal.fire({
//             position: 'top-end',
//             icon: 'error',
//             title: 'something went wrong',
//             showConfirmButton: false,
//             timer: 1500
//           })
//         })
//       }
//     })
//   }

//   async function updateProductTagFunc(id, tag) {
//     try {
//       await axios.put(`${Url}/product/update-product-tag/${id}`, {tag})
//       fetchDataFunc()
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   function onPageChange(pageNumber) {
//     setCurrentPage(pageNumber)
//   }

//   function changeLimitFunc(limitNumber) {
//     setLimit(limitNumber)
//     setCurrentPage(1)
//   }

//   function handleTabChange(event, newValue) {
//     setActiveTab(newValue)
//     setCurrentPage(1)
//   }
 
//   useEffect(() => {
//     fetchDataFunc()
//   }, [])

//   useEffect(() => {
//     dataSet()
//   }, [productAllData])

//   return (
//     <>
//       <Helmet>
//         <title> Dashboard: Products | Doozie-do </title>
//       </Helmet>

//       <Container>
//         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
//           <Typography variant="h4" gutterBottom>
//             Product
//           </Typography>
//           <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
//             <Link className='text-white ' to="/dashboard/add-product">Add New</Link>
//           </Button>
//         </Stack>
//       </Container>

//       <Container>
//         <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
//           <Tabs value={activeTab} onChange={handleTabChange}>
//             <Tab label="All Products" />
//             <Tab label="Devi Shera" />
//             <Tab label="Doozie-do" />
//           </Tabs>
//         </Box>
//       </Container>

//       <Container className=' '>
//         <div className='d-flex align-items-center justify-content-between felx-wrap bg-lightgray rounded-top p-3'>
//           <div>
//             <form>
//               <input type='text' onChange={e => searchfunc(e.target.value)} placeholder='Search' className='form-control' />
//             </form>
//           </div>
//           <div className='d-flex gap-2 align-items-top'>
//             <div>
//               <p className='mb-1'>Limit</p>
//               <select value={limit} onChange={e => changeLimitFunc(e.target.value)} className='border-0 rounded p-1'>
//                 <option value="5">5</option>
//                 <option value="10">10</option>
//                 <option value="20">20</option>
//                 <option value="30">30</option>
//                 <option value="50">50</option>
//                 <option value="100">100</option>
//               </select>
//             </div>
//           </div>
//         </div>
//       </Container>

//       <Container>
//         <section className='table-responsive'>
//           <table className='table table-striped table-bordered text-center table-hover align-top'>
//             <thead className='table-primary'>
//               <tr className='align-top'>
//                 <th>Product Image</th>
//                 <th>Product Name</th>
//                 <th>Seller Name</th>
//                 <th>Character</th>
//                 <th>SubCharacter</th>
//                 <th>MRP</th>
//                 <th>Sale Price</th>
//                 <th>Tag</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData.data?.map((cv, i) => {
//                 return (
//                   <tr className='text-center' key={i}>
//                     <td className=''>
//                       <img src={`${cv.thumbnailImage}`} alt="" className='img-fluid mx-auto' style={{ width: "70px" }} />
//                     </td>
//                     <td className=''>{cv.productName}</td>
//                     <td className=''>{cv.sellerName}</td>
//                     <td className=''>{cv.character}</td>
//                     <td className=''>{cv.subcharacter}</td>
//                     <td className=''>&#8377; {cv.mrp}</td>
//                     <td className=''>&#8377; {cv.salePrice}</td>
//                     <td>
//                       <select name="tags" id="" className='form-select' value={cv.tags} onChange={(e)=>updateProductTagFunc(cv._id, e.target.value)}>
//                         <option value="">Null</option>
//                         <option value="top picks">Top Picks</option>
//                         <option value="new arrival">New Arrival</option>
//                       </select>
//                     </td>
//                     <td>
//                       <div className='d-flex align-items-center'>
//                         <Link to={`/dashboard/updateproduct/${cv._id}`} className='btn border-0'>
//                           <i className="fa-solid fa-pen-to-square text-warning fa-lg " /> <br />
//                         </Link>
//                         <button className='btn border-0' onClick={e => productDrop(cv._id)}>
//                           <i className="fa-solid fa-trash text-danger fa-lg" />
//                         </button>
//                         <Link className='btn border-0' to={`/dashboard/product/${cv._id}`}>
//                           <i className="fa-solid fa-eye text-primary fa-lg" />
//                         </Link>
//                       </div>
//                     </td>
//                   </tr>
//                 )
//               })}
//             </tbody>
//           </table>
//         </section>

//         <nav>
//           <ul className="pagination justify-content-center">
//             <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//               <button className="page-link" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
//                 Previous
//               </button>
//             </li>

//             {Array.from({ length: paginatedData.totalPages }, (_, index) => index + 1).map((page) => (
//               <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
//                 <button className="page-link" onClick={() => onPageChange(page)}>
//                   {page}
//                 </button>
//               </li>
//             ))}

//             <li className={`page-item ${currentPage === paginatedData.totalPages ? "disabled" : ""}`}>
//               <button className="page-link" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === paginatedData.totalPages}>
//                 Next
//               </button>
//             </li>
//           </ul>
//         </nav>
//       </Container>

//       <Container>
//         {/* {searchData ? <ProductDataList data={searchData} /> : <ProductDataList data={dataValue} />} */}
//       </Container>
//     </>
//   );
// }

// export default ProductsPage















// /* eslint-disable object-shorthand */
// /* eslint-disable react/jsx-no-bind */
// import { Helmet } from 'react-helmet-async';
// import { Link } from 'react-router-dom';
// // @mui
// import { Button, Container, Stack, Typography, Tabs, Tab, Box } from '@mui/material';
// import { useSelector, useDispatch } from 'react-redux';
// import { useEffect, useState, useMemo } from 'react';
// import axios from 'axios';
// import Swal from 'sweetalert2';

// // components
// import Iconify from '../components/iconify';
// import { Url } from '../url/url';

// // ✅ Redux thunk import karo
// import { productdata } from '../redux/slice/product'; // apna sahi path check karo

// // ----------------------------------------------------------------------

// const ProductsPage = () => {
//   const dispatch = useDispatch(); // ✅ dispatch hook
//   const productAllData = useSelector(store => store.product.data) || []; // ✅ Redux store se data, fallback []

//   const [searchData, setSearchValueData] = useState();
//   const [limit, setLimit] = useState(5);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [activeTab, setActiveTab] = useState(0);

//   // ✅ Search function
//   async function searchfunc(value) {
//     if (value.length > 0) {
//       let findproduct = await axios.get(`${Url}/product/search/${value}`);
//       findproduct = findproduct.data;
//       setSearchValueData(findproduct);
//     } else {
//       setSearchValueData();
//     }
//   }

//   // ✅ useMemo se filtered data — productAllData directly use karo
//   const filteredProducts = useMemo(() => {
//     // ✅ Safety check — agar productAllData array nahi hai toh [] return karo
//     if (!Array.isArray(productAllData)) return [];
//     let filtered = [...productAllData];

//     if (activeTab === 1) {
//       filtered = filtered.filter(
//         (item) => item.sellerName && item.sellerName === 'Devi Shera'
//       );
//     } else if (activeTab === 2) {
//       filtered = filtered.filter(
//         (item) =>
//           item.sellerName && item.sellerName.toLowerCase() === 'doozie-do'
//       );
//     }

//     return filtered;
//   }, [productAllData, activeTab]);

//   // ✅ useMemo se paginated data
//   const paginatedData = useMemo(() => {
//     const totalCount = filteredProducts.length;
//     const pages = Math.ceil(totalCount / limit);

//     const start = (currentPage - 1) * limit;
//     const end = start + Number(limit);
//     const paginated = filteredProducts.slice(start, end);

//     return {
//       data: paginated,
//       totalCount: totalCount,
//       totalPages: pages || 1,
//       currentPage: currentPage,
//     };
//   }, [filteredProducts, limit, currentPage]);

//   // ✅ Delete function — delete ke baad re-dispatch karo
//   async function productDrop(id) {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!',
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         await axios
//           .delete(`${Url}/product/delete/${id}`)
//           .then(() => {
//             Swal.fire({
//               position: 'top-end',
//               icon: 'success',
//               title: 'Item Delete Successfully',
//               showConfirmButton: false,
//               timer: 1000,
//             });
//             dispatch(productdata()); // ✅ delete ke baad Redux se fresh data lao
//           })
//           .catch(() => {
//             Swal.fire({
//               position: 'top-end',
//               icon: 'error',
//               title: 'something went wrong',
//               showConfirmButton: false,
//               timer: 1500,
//             });
//           });
//       }
//     });
//   }

//   // ✅ Tag update function
//   async function updateProductTagFunc(id, tag) {
//     try {
//       await axios.put(`${Url}/product/update-product-tag/${id}`, { tag });
//       dispatch(productdata()); // ✅ tag update ke baad fresh data
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   function onPageChange(pageNumber) {
//     setCurrentPage(pageNumber);
//   }

//   function changeLimitFunc(limitNumber) {
//     setLimit(limitNumber);
//     setCurrentPage(1);
//   }

//   function handleTabChange(event, newValue) {
//     setActiveTab(newValue);
//     setCurrentPage(1);
//   }

//   // ✅ Sirf ek baar Redux dispatch karo — data Redux store mein aa jayega
//   useEffect(() => {
//     dispatch(productdata());
//   }, []);

//   return (
//     <>
//       <Helmet>
//         <title> Dashboard: Products | Doozie-do </title>
//       </Helmet>

//       <Container>
//         <Stack
//           direction="row"
//           alignItems="center"
//           justifyContent="space-between"
//           mb={3}
//         >
//           <Typography variant="h4" gutterBottom>
//             Product
//           </Typography>
//           <Button
//             variant="contained"
//             startIcon={<Iconify icon="eva:plus-fill" />}
//           >
//             <Link className="text-white" to="/dashboard/add-product">
//               Add New
//             </Link>
//           </Button>
//         </Stack>
//       </Container>

//       <Container>
//         <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
//           <Tabs value={activeTab} onChange={handleTabChange}>
//             <Tab label="All Products" />
//             <Tab label="Devi Shera" />
//             <Tab label="Doozie-do" />
//           </Tabs>
//         </Box>
//       </Container>

//       <Container>
//         <div className="d-flex align-items-center justify-content-between felx-wrap bg-lightgray rounded-top p-3">
//           <div>
//             <form>
//               <input
//                 type="text"
//                 onChange={(e) => searchfunc(e.target.value)}
//                 placeholder="Search"
//                 className="form-control"
//               />
//             </form>
//           </div>
//           <div className="d-flex gap-2 align-items-top">
//             <div>
//               <p className="mb-1">Limit</p>
//               <select
//                 value={limit}
//                 onChange={(e) => changeLimitFunc(e.target.value)}
//                 className="border-0 rounded p-1"
//               >
//                 <option value="5">5</option>
//                 <option value="10">10</option>
//                 <option value="20">20</option>
//                 <option value="30">30</option>
//                 <option value="50">50</option>
//                 <option value="100">100</option>
//               </select>
//             </div>
//           </div>
//         </div>
//       </Container>

//       <Container>
//         <section className="table-responsive">
//           <table className="table table-striped table-bordered text-center table-hover align-top">
//             <thead className="table-primary">
//               <tr className="align-top">
//                 <th>Product Image</th>
//                 <th>Product Name</th>
//                 {/* <th>Seller Name</th> */}
//                 <th>Category</th>
//                 <th>SubCategory</th>
//                 <th>MRP</th>
//                 <th>Sale Price</th>
//                 <th>Tag</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData.data?.map((cv, i) => (
//                 <tr className="text-center" key={i}>
//                   <td>
//                     <img
//                       src={`${cv.thumbnailImage}`}
//                       alt=""
//                       className="img-fluid mx-auto"
//                       style={{ width: '70px' }}
//                     />
//                   </td>
//                   <td>{cv.productName}</td>
//                   {/* <td>{cv.sellerName}</td> */}
//                   <td>{cv.category}</td>
//                   <td>{cv.subCategory}</td>
//                   <td>&#8377; {cv.mrp}</td>
//                   <td>&#8377; {cv.salePrice}</td>
//                   <td>
//                     <select
//                       name="tags"
//                       className="form-select"
//                       value={cv.tags}
//                       onChange={(e) =>
//                         updateProductTagFunc(cv._id, e.target.value)
//                       }
//                     >
//                       <option value="">Null</option>
//                       <option value="top picks">Top Picks</option>
//                       <option value="new arrival">New Arrival</option>
//                     </select>
//                   </td>
//                   <td>
//                     <div className="d-flex align-items-center">
//                       <Link
//                         to={`/dashboard/updateproduct/${cv._id}`}
//                         className="btn border-0"
//                       >
//                         <i className="fa-solid fa-pen-to-square text-warning fa-lg" />
//                       </Link>
//                       <button
//                         className="btn border-0"
//                         onClick={() => productDrop(cv._id)}
//                       >
//                         <i className="fa-solid fa-trash text-danger fa-lg" />
//                       </button>
//                       <Link
//                         className="btn border-0"
//                         to={`/dashboard/product/${cv._id}`}
//                       >
//                         <i className="fa-solid fa-eye text-primary fa-lg" />
//                       </Link>
//                     </div>
//                   </td>
//                 </tr>
//               ))}

//               {/* ✅ Agar data nahi hai toh message dikhao */}
//               {paginatedData.data?.length === 0 && (
//                 <tr>
//                   <td colSpan="9" className="text-center py-4 text-muted">
//                     No products found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </section>

//         {/* ✅ Pagination */}
//         <nav>
//           <ul className="pagination justify-content-center">
//             <li
//               className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}
//             >
//               <button
//                 className="page-link"
//                 onClick={() => onPageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//               >
//                 Previous
//               </button>
//             </li>

//             {Array.from(
//               { length: paginatedData.totalPages },
//               (_, index) => index + 1
//             ).map((page) => (
//               <li
//                 key={page}
//                 className={`page-item ${currentPage === page ? 'active' : ''}`}
//               >
//                 <button
//                   className="page-link"
//                   onClick={() => onPageChange(page)}
//                 >
//                   {page}
//                 </button>
//               </li>
//             ))}

//             <li
//               className={`page-item ${
//                 currentPage === paginatedData.totalPages ? 'disabled' : ''
//               }`}
//             >
//               <button
//                 className="page-link"
//                 onClick={() => onPageChange(currentPage + 1)}
//                 disabled={currentPage === paginatedData.totalPages}
//               >
//                 Next
//               </button>
//             </li>
//           </ul>
//         </nav>
//       </Container>
//     </>
//   );
// };

// export default ProductsPage;












// /* eslint-disable object-shorthand */
// /* eslint-disable react/jsx-no-bind */
// import { Helmet } from 'react-helmet-async';
// import { Link } from 'react-router-dom';
// import { Button, Container, Stack, Typography } from '@mui/material';
// import { useSelector, useDispatch } from 'react-redux';
// import { useEffect, useState, useMemo } from 'react';
// import axios from 'axios';
// import Swal from 'sweetalert2';

// import Iconify from '../components/iconify';
// import { Url } from '../url/url';
// import { productdata } from '../redux/slice/product';

// const ProductsPage = () => {
//   const dispatch = useDispatch();
//   const productAllData = useSelector(store => store.product.data) || [];

//   const [searchData, setSearchValueData] = useState();
//   const [limit, setLimit] = useState(5);
//   const [currentPage, setCurrentPage] = useState(1);

//   async function searchfunc(value) {
//     if (value.length > 0) {
//       let findproduct = await axios.get(`${Url}/product/search/${value}`);
//       findproduct = findproduct.data;
//       setSearchValueData(findproduct);
//     } else {
//       setSearchValueData();
//     }
//   }

//   const displayData = searchData || (Array.isArray(productAllData) ? productAllData : []);

//   const paginatedData = useMemo(() => {
//     const totalCount = displayData.length;
//     const pages = Math.ceil(totalCount / limit);
//     const start = (currentPage - 1) * limit;
//     const end = start + Number(limit);
//     const paginated = displayData.slice(start, end);
//     return {
//       data: paginated,
//       totalCount: totalCount,
//       totalPages: pages || 1,
//       currentPage: currentPage,
//     };
//   }, [displayData, limit, currentPage]);

//   async function productDrop(id) {
//     Swal.fire({
//       title: 'Are you sure?',
//       text: "You won't be able to revert this!",
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#3085d6',
//       cancelButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!',
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         await axios
//           .delete(`${Url}/product/delete/${id}`)
//           .then(() => {
//             Swal.fire({
//               position: 'top-end',
//               icon: 'success',
//               title: 'Item Delete Successfully',
//               showConfirmButton: false,
//               timer: 1000,
//             });
//             dispatch(productdata());
//           })
//           .catch(() => {
//             Swal.fire({
//               position: 'top-end',
//               icon: 'error',
//               title: 'something went wrong',
//               showConfirmButton: false,
//               timer: 1500,
//             });
//           });
//       }
//     });
//   }

//   async function updateProductTagFunc(id, tag) {
//     try {
//       await axios.put(`${Url}/product/update-product-tag/${id}`, { tag });
//       dispatch(productdata());
//     } catch (error) {
//       console.log(error);
//     }
//   }

//   function onPageChange(pageNumber) {
//     setCurrentPage(pageNumber);
//   }

//   function changeLimitFunc(limitNumber) {
//     setLimit(limitNumber);
//     setCurrentPage(1);
//   }

//   useEffect(() => {
//     dispatch(productdata());
//   }, []);

//   return (
//     <>
//       <Helmet>
//         <title> Dashboard: Products | Doozie-do </title>
//       </Helmet>

//       <Container>
//         <Stack
//           direction="row"
//           alignItems="center"
//           justifyContent="space-between"
//           mb={3}
//         >
//           <Typography variant="h4" gutterBottom>
//             Product
//           </Typography>
//           <Button
//             variant="contained"
//             startIcon={<Iconify icon="eva:plus-fill" />}
//           >
//             <Link className="text-white" to="/dashboard/add-product">
//               Add New
//             </Link>
//           </Button>
//         </Stack>
//       </Container>

//       <Container>
//         <div className="d-flex align-items-center justify-content-between felx-wrap bg-lightgray rounded-top p-3">
//           <div>
//             <form>
//               <input
//                 type="text"
//                 onChange={(e) => searchfunc(e.target.value)}
//                 placeholder="Search"
//                 className="form-control"
//               />
//             </form>
//           </div>
//           <div className="d-flex gap-2 align-items-top">
//             <div>
//               <p className="mb-1">Limit</p>
//               <select
//                 value={limit}
//                 onChange={(e) => changeLimitFunc(e.target.value)}
//                 className="border-0 rounded p-1"
//               >
//                 <option value="5">5</option>
//                 <option value="10">10</option>
//                 <option value="20">20</option>
//                 <option value="30">30</option>
//                 <option value="50">50</option>
//                 <option value="100">100</option>
//               </select>
//             </div>
//           </div>
//         </div>
//       </Container>

//       <Container>
//         <section className="table-responsive">
//           <table className="table table-striped table-bordered text-center table-hover align-top">
//             <thead className="table-primary">
//               <tr className="align-top">
//                 <th>Product Image</th>
//                 <th>Product Name</th>
//                 <th>Category</th>
//                 <th>SubCategory</th>
//                 <th>MRP</th>
//                 <th>Sale Price</th>
//                 <th>Tag</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {paginatedData.data?.map((cv, i) => (
//                 <tr className="text-center" key={i}>
//                   <td>
//                     <img
//                       src={`${cv.thumbnailImage}`}
//                       alt=""
//                       className="img-fluid mx-auto"
//                       style={{ width: '70px' }}
//                     />
//                   </td>
//                   <td>{cv.productName}</td>
//                   <td>{cv.category}</td>
//                   <td>{cv.subCategory}</td>
//                   <td>&#8377; {cv.mrp}</td>
//                   <td>&#8377; {cv.salePrice}</td>
//                   <td>
//                     <select
//                       name="tags"
//                       className="form-select"
//                       value={cv.tags}
//                       onChange={(e) =>
//                         updateProductTagFunc(cv._id, e.target.value)
//                       }
//                     >
//                       <option value="">Null</option>
//                       <option value="top picks">Top Picks</option>
//                       <option value="new arrival">New Arrival</option>
//                     </select>
//                   </td>
//                   <td>
//                     <div className="d-flex align-items-center">
//                       <Link
//                         to={`/dashboard/updateproduct/${cv._id}`}
//                         className="btn border-0"
//                       >
//                         <i className="fa-solid fa-pen-to-square text-warning fa-lg" />
//                       </Link>
//                       <button
//                         className="btn border-0"
//                         onClick={() => productDrop(cv._id)}
//                       >
//                         <i className="fa-solid fa-trash text-danger fa-lg" />
//                       </button>
//                       <Link
//                         className="btn border-0"
//                         to={`/dashboard/product/${cv._id}`}
//                       >
//                         <i className="fa-solid fa-eye text-primary fa-lg" />
//                       </Link>
//                     </div>
//                   </td>
//                 </tr>
//               ))}

//               {paginatedData.data?.length === 0 && (
//                 <tr>
//                   <td colSpan="8" className="text-center py-4 text-muted">
//                     No products found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </section>

//         <nav>
//           <ul className="pagination justify-content-center">
//             <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
//               <button
//                 className="page-link"
//                 onClick={() => onPageChange(currentPage - 1)}
//                 disabled={currentPage === 1}
//               >
//                 Previous
//               </button>
//             </li>

//             {Array.from(
//               { length: paginatedData.totalPages },
//               (_, index) => index + 1
//             ).map((page) => (
//               <li
//                 key={page}
//                 className={`page-item ${currentPage === page ? 'active' : ''}`}
//               >
//                 <button
//                   className="page-link"
//                   onClick={() => onPageChange(page)}
//                 >
//                   {page}
//                 </button>
//               </li>
//             ))}

//             <li
//               className={`page-item ${
//                 currentPage === paginatedData.totalPages ? 'disabled' : ''
//               }`}
//             >
//               <button
//                 className="page-link"
//                 onClick={() => onPageChange(currentPage + 1)}
//                 disabled={currentPage === paginatedData.totalPages}
//               >
//                 Next
//               </button>
//             </li>
//           </ul>
//         </nav>
//       </Container>
//     </>
//   );
// };

// export default ProductsPage;









/* eslint-disable object-shorthand */
/* eslint-disable react/jsx-no-bind */
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import {
  Button, Container, Stack, Typography, Box, Card,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Avatar, Chip, IconButton, TextField, Select, MenuItem,
  Pagination, FormControl, InputLabel, Tooltip, InputAdornment,
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import Iconify from '../components/iconify';
import { Url } from '../url/url';
import { productdata } from '../redux/slice/product';

const ProductsPage = () => {
  const dispatch = useDispatch();
  const productAllData = useSelector((store) => store.product.data) || [];

  const [searchData, setSearchValueData] = useState();
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  async function searchfunc(value) {
  if (value.length > 0) {
    const findproduct = await axios.get(`${Url}/product/search/${value}`);  // let → const
    setSearchValueData(findproduct.data);
  } else {
    setSearchValueData();
  }
}

  const displayData = searchData || (Array.isArray(productAllData) ? productAllData : []);

  const paginatedData = useMemo(() => {
    const totalCount = displayData.length;
    const pages = Math.ceil(totalCount / limit);
    const start = (currentPage - 1) * limit;
    const paginated = displayData.slice(start, start + Number(limit));
    return { data: paginated, totalCount, totalPages: pages || 1, currentPage };
  }, [displayData, limit, currentPage]);

  async function productDrop(id) {
    Swal.fire({
      title: 'Are you sure?', text: "You won't be able to revert this!", icon: 'warning',
      showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios.delete(`${Url}/product/delete/${id}`)
          .then(() => {
            Swal.fire({ position: 'top-end', icon: 'success', title: 'Deleted Successfully', showConfirmButton: false, timer: 1000 });
            dispatch(productdata());
          })
          .catch(() => {
            Swal.fire({ position: 'top-end', icon: 'error', title: 'Something went wrong', showConfirmButton: false, timer: 1500 });
          });
      }
    });
  }

  async function updateProductTagFunc(id, tag) {
    try {
      await axios.put(`${Url}/product/update-product-tag/${id}`, { tag });
      dispatch(productdata());
    } catch (error) { console.log(error); }
  }

  useEffect(() => { dispatch(productdata()); }, []);

  const tagColor = (tag) => {
    if (tag === 'top picks') return 'warning';
    if (tag === 'new arrival') return 'success';
    return 'default';
  };

  return (
    <>
      <Helmet><title>Products | Admin</title></Helmet>

      <Container maxWidth="xl">
        {/* Header */}
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 4 }}>
          <Box>
            <Typography variant="h4" fontWeight={500}>Products</Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              {displayData.length} total products
            </Typography>
          </Box>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-fill" />}
            component={Link}
            to="/dashboard/add-product"
            sx={{ borderRadius: 2 }}
          >
            Add New Product
          </Button>
        </Stack>

        {/* Filter Bar */}
        <Card sx={{ p: 2, mb: 3, borderRadius: 3, boxShadow: 'none', border: '1px solid', borderColor: 'divider' }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2}>
            <TextField
              size="small"
              placeholder="Search products..."
              onChange={(e) => searchfunc(e.target.value)}
              sx={{ width: 280 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled' }} />
                  </InputAdornment>
                ),
              }}
            />
            <FormControl size="small" sx={{ minWidth: 100 }}>
              <InputLabel>Per page</InputLabel>
              <Select
                value={limit}
                label="Per page"
                onChange={(e) => { setLimit(e.target.value); setCurrentPage(1); }}
              >
                {[5, 10, 20, 30, 50, 100].map((n) => (
                  <MenuItem key={n} value={n}>{n}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>
        </Card>

        {/* Table */}
        <Card sx={{ borderRadius: 3, boxShadow: 'none', border: '1px solid', borderColor: 'divider', overflow: 'hidden' }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: 'background.neutral' }}>
                  {['Product', 'Category', 'SubCategory', 'MRP', 'Sale Price', 'Tag', 'Actions'].map((h) => (
                    <TableCell key={h} sx={{ fontWeight: 600, fontSize: 13, color: 'text.secondary', py: 1.5 }}>
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedData.data?.map((cv) => (
                  <TableRow
                    key={cv._id}
                    hover
                    sx={{ '&:last-child td': { border: 0 } }}
                  >
                    {/* Product */}
                    <TableCell>
                      <Stack direction="row" alignItems="center" spacing={1.5}>
                        <Avatar
                          src={cv.thumbnailImage}
                          alt={cv.productName}
                          variant="rounded"
                          sx={{ width: 52, height: 52, borderRadius: 2, border: '1px solid', borderColor: 'divider' }}
                        />
                        <Typography variant="body2" fontWeight={500} sx={{ maxWidth: 180 }}>
                          {cv.productName}
                        </Typography>
                      </Stack>
                    </TableCell>

                    {/* Category */}
                    <TableCell>
                      <Typography variant="body2" textTransform="capitalize">{cv.category}</Typography>
                    </TableCell>

                    {/* SubCategory */}
                    <TableCell>
                      <Typography variant="body2" textTransform="capitalize">{cv.subCategory}</Typography>
                    </TableCell>

                    {/* MRP */}
                    <TableCell>
                      <Typography variant="body2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
                        ₹{cv.mrp}
                      </Typography>
                    </TableCell>

                    {/* Sale Price */}
                    <TableCell>
                      <Typography variant="body2" fontWeight={600} color="success.main">
                        ₹{cv.salePrice}
                      </Typography>
                    </TableCell>

                    {/* Tag */}
                    <TableCell>
                      <Select
                        size="small"
                        value={cv.tags || ''}
                        onChange={(e) => updateProductTagFunc(cv._id, e.target.value)}
                        displayEmpty
                        sx={{ fontSize: 13, minWidth: 130, borderRadius: 2 }}
                        renderValue={(val) =>
                          val ? (
                            <Chip label={val} size="small" color={tagColor(val)} sx={{ fontSize: 11, textTransform: 'capitalize' }} />
                          ) : (
                            <Typography variant="body2" color="text.disabled">None</Typography>
                          )
                        }
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="top picks">Top Picks</MenuItem>
                        <MenuItem value="new arrival">New Arrival</MenuItem>
                      </Select>
                    </TableCell>

                    {/* Actions */}
                    <TableCell>
                      <Stack direction="row" spacing={0.5}>
                        <Tooltip title="Edit product">
                          <IconButton
                            component={Link}
                            to={`/dashboard/updateproduct/${cv._id}`}
                            size="small"
                            sx={{ color: 'warning.main', bgcolor: 'warning.lighter', borderRadius: 1.5, '&:hover': { bgcolor: 'warning.light' } }}
                          >
                            <Iconify icon="eva:edit-fill" width={17} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="View product">
                          <IconButton
                            component={Link}
                            to={`/dashboard/product/${cv._id}`}
                            size="small"
                            sx={{ color: 'info.main', bgcolor: 'info.lighter', borderRadius: 1.5, '&:hover': { bgcolor: 'info.light' } }}
                          >
                            <Iconify icon="eva:eye-fill" width={17} />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete product">
                          <IconButton
                            size="small"
                            onClick={() => productDrop(cv._id)}
                            sx={{ color: 'error.main', bgcolor: 'error.lighter', borderRadius: 1.5, '&:hover': { bgcolor: 'error.light' } }}
                          >
                            <Iconify icon="eva:trash-2-fill" width={17} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))}

                {paginatedData.data?.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={7} sx={{ textAlign: 'center', py: 6 }}>
                      <Iconify icon="eva:inbox-outline" width={40} sx={{ color: 'text.disabled', mb: 1 }} />
                      <Typography color="text.disabled">No products found</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2.5, py: 2, borderTop: '1px solid', borderColor: 'divider' }}>
            <Typography variant="body2" color="text.secondary">
              Showing {((currentPage - 1) * limit) + 1}–{Math.min(currentPage * limit, displayData.length)} of {displayData.length}
            </Typography>
            <Pagination
              count={paginatedData.totalPages}
              page={currentPage}
              onChange={(_, page) => setCurrentPage(page)}
              color="primary"
              shape="rounded"
              size="small"
            />
          </Box>
        </Card>
      </Container>
    </>
  );
};

export default ProductsPage;